module.exports = __webpack_public_path__ + "img/gsndc2765_2.bb0736d3.svg";